module.exports = __webpack_public_path__ + "img/1-1-IMG_3001.1c35d3a0.png";